<template>
    <arb-basic-tooltips :position="position" :maxWidth="maxWidth">
      <v-btn
        v-if="className === ''"
        icon
        :color="color"
        slot="tip-icon"
        @click="clickEventHandler">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
      <i
        v-else
        :class="`${className} ${icon}`"
         @click="clickEventHandler"
         slot="tip-icon"
      ></i>
      <span slot="tip-content">{{ toolTipData }}</span>
    </arb-basic-tooltips>
</template>

<script>
export default {
  name: 'arb-event-tooltips',
  props: {
    className: {
      type: String,
      default: ''
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxWidth: {
      type: String,
      default: '800px'
    },
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String
    },
    toolTipData: {
      type: String
    }
  },
  methods: {
    clickEventHandler () {
      this.$emit('click')
    }
  }
}
</script>
